<template>
  <header class="ksm-header">
    <router-link
      tag="a"
      to="/"
      class="ksm-header__title ksm-link-img"
      v-html="$_getSvg('kurt-merz-schwitters-typo.svg')"
    ></router-link>
    <!-- <div class="__subtitle ksm-flex-00auto" v-html="$_getSvg('die-reihe-merz-typo.svg')"></div> -->
    <div class="ksm-flex-1 ksm-flex-column">
      <div class="ksm-flex-1"></div>
      <nav-view style="order:0"></nav-view>
    </div>
    <!-- <div style="color:#eee; font-size:10pt; margin:10px">Stand 07.11.2022</div> -->
  </header>
</template>

<script>
import Nav from "./Nav.vue";
export default {
  data() {
    return {};
  },
  components: {
    "nav-view": Nav
  },
  computed: {
    isHome() {
      return this.$route.name == "home";
    }
  },
  methods: {}
};
</script>

<style lang="scss">
.ksm-header {
  @extend .ksm-flex;
  background-color: rgb(0, 40, 87);
  flex-wrap: wrap;
  .ksm-header__title {
    @extend .ksm-flex-00auto;
    order: 0;
    width: 250px;
    padding: 2px 10px;
    height: 60px;
    svg {
      height: 100%;
      width: 100%;
    }
  }
  position: relative;
  padding: 0px 20px;
}
</style>


// WEBPACK FOOTER //
// Head.vue?237809e2